if (!customElements.get("copy-code-modal")) {
  class CopyCodeComponent extends HTMLElement {
    constructor() {
      super();
      const copy_btn = this.querySelector(".code_text_copy");
      const copy_text = this.querySelector(".sale_codes");
      let copy_btn_content = copy_btn?.innerHTML;
      copy_btn?.addEventListener('click', function() {
        const textToCopy = copy_text.textContent;
        navigator.clipboard.writeText(textToCopy).then(function() {
        copy_btn.innerHTML = `<span>COPIED</span>`
          setTimeout(() => {
            copy_btn.innerHTML = copy_btn_content;
        }, 5000);
        }).catch(function(error) {
          console.error('Copy failed', error);
        });
      });
    }
  }
  customElements.define('copy-code-modal', CopyCodeComponent);
}